import { Flex } from "@mantine/core";
import { Fragment } from "react";

import DatePickerInput from "../_FormInputs/DatePickerInput";
import Select from "../_FormInputs/Select";

interface Props {
  control: any;
  datesSelectorWatchValue: string;
  disabled?: boolean;
  startInputName: string;
  endInputName: string;
  datesInputName: string;
  dateTypeInputName?: string;
  additionalSetStartDate?: (date: string) => void;
  additionalSetEndDate?: (date: string) => void;
}

const ReportDatesInputs = ({
  control,
  datesSelectorWatchValue,
  startInputName,
  endInputName,
  datesInputName,
  dateTypeInputName,
  disabled,
  additionalSetStartDate,
  additionalSetEndDate,
}: Props) => {
  return (
    <Fragment>
      {dateTypeInputName && (
        <Select
          control={control}
          name={dateTypeInputName}
          maw={"550px"}
          mt={10}
          disabled={disabled}
          label="Date Type"
          data={[
            { value: "entrydate", label: "Entry Date" },
            { value: "opendate", label: "Open Date" },
          ]}
        />
      )}
      <Select
        control={control}
        name={datesInputName}
        maw={"550px"}
        mt={10}
        disabled={disabled}
        label="Date Lengths"
        data={[
          { value: "0", label: "Last Month" },
          { value: "1", label: "Last 3 Months" },
          { value: "2", label: "Last 6 Months" },
          { value: "3", label: "Last 12 Months" },
          { value: "4", label: "Custom Range" },
        ]}
      />
      {datesSelectorWatchValue === "4" && (
        <Flex w="100%" gap={10}>
          <DatePickerInput
            mt={10}
            flex={1}
            control={control}
            name={startInputName}
            disabled={Boolean(disabled)}
            label="Start date"
            placeholder="Pick date"
            valueFormat="DD MMM YYYY"
            additionalSetISODate={additionalSetStartDate}
          />
          <DatePickerInput
            mt={10}
            flex={1}
            control={control}
            name={endInputName}
            disabled={Boolean(disabled)}
            label="End date"
            placeholder="Pick date"
            valueFormat="DD MMM YYYY"
            additionalSetISODate={additionalSetEndDate}
          />
        </Flex>
      )}
    </Fragment>
  );
};
export default ReportDatesInputs;
